import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { LayoutDashboard, Package, ShoppingBag, Users, LogOut, Upload, CreditCard, Phone, BarChart3 } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/bulk-import", label: "Bulk Import", icon: Upload },
  { to: "/admin/payment-settings", label: "Payment", icon: CreditCard },
  { to: "/admin/contact-settings", label: "Contact", icon: Phone },
  { to: "/admin/customers", label: "Customers", icon: Users },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) nav("/login");
  }, [loading, user, nav]);

  if (loading || !user || user.role !== "admin") return <div className="container-x py-20 text-center">Loading…</div>;

  return (
    <div className="min-h-screen bg-muted/30" data-testid="admin-layout">
      <div className="grid md:grid-cols-[240px_1fr] min-h-screen">
        <aside className="bg-espresso text-ivory p-6 flex flex-col">
          <div className="mb-8 flex items-center gap-3">
            <img src="/adiyogi-logo.png" alt="AdiYogi Handcrafts" className="h-11 w-auto object-contain bg-ivory rounded p-1" />
            <div className="leading-tight">
              <div className="font-serif text-base">AdiYogi Handcrafts</div>
              <div className="text-[10px] uppercase tracking-widest opacity-70">Admin</div>
            </div>
          </div>
          <nav className="flex-1 space-y-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={({isActive}) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm ${isActive ? "bg-[#B8860B] text-ivory" : "hover:bg-white/5"}`} data-testid={`admin-nav-${n.label.toLowerCase()}`}>
                <n.icon className="w-4 h-4" strokeWidth={1.5} /> {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-6 pt-4 border-t border-white/10">
            <div className="text-xs opacity-70 mb-2">Signed in as</div>
            <div className="text-sm">{user.email}</div>
            <button onClick={() => { logout(); nav("/"); }} className="mt-3 text-xs opacity-80 hover:opacity-100 flex items-center gap-1" data-testid="admin-logout"><LogOut className="w-3 h-3" strokeWidth={1.5} /> Sign out</button>
          </div>
        </aside>
        <main className="p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
